import config from "@/config";
import { scopedStorage } from "../../../shared-client/guestSession.mjs";

export const session = scopedStorage(localStorage, config.api.baseURL, config.SITE_SLUG);
export const pendingGuests = scopedStorage(sessionStorage, config.api.baseURL, config.SITE_SLUG, "claims");
// Do not leave old unscoped bearer credentials available to legacy helpers.
["token", "user", "userId"].forEach(key => localStorage.removeItem(key));
